import { RefreshCcw, X } from 'lucide-react';
import { Avatar } from '../../../../../design-system/avatar/avatar/avatar';
import { Button } from '../../../../../design-system/button/button';
import { Inline } from '../../../../../design-system/inline/inline';
import { Stack } from '../../../../../design-system/stack/stack';
import { getJointAvatarDescription } from '../utils/get-joint-avatar-description';

type BeneficiaryReviewCardProps = {
  name: string;
  date: string;
  reference?: string | null;
  formattedAmount: string;
  onChangeMatchedTransaction: () => void;
  onRejectInvoice: () => void;
};

export const BeneficiaryReviewCard = ({
  name,
  date,
  reference,
  formattedAmount,
  onChangeMatchedTransaction,
  onRejectInvoice,
}: BeneficiaryReviewCardProps) => {
  const cardDescription = getJointAvatarDescription({
    item1: date,
    item2: reference,
  });

  return (
    <Inline
      justify="between"
      className="w-full space-y-3 rounded-[10px] border-[0.5px] border-seapoint-gray-border bg-white px-4 py-3"
    >
      <Inline space={3}>
        <Avatar name={name} size="sm" />

        <Stack space={0} className="min-w-0 flex-1">
          <p className="text-sm font-medium leading-6 tracking-tight text-black">{name}</p>

          {cardDescription && (
            <p className="text-xs font-normal leading-6 tracking-tight text-seapoint-gray-text">{cardDescription}</p>
          )}

          <Stack>
            <Button
              variant="link"
              size="none"
              iconLeft={<RefreshCcw />}
              className="p-0 text-black"
              onClick={onChangeMatchedTransaction}
            >
              Change matched transaction
            </Button>

            <Button
              variant="link"
              size="none"
              iconLeft={<X />}
              className="p-0 text-seapoint-red"
              onClick={onRejectInvoice}
            >
              Reject invoice
            </Button>
          </Stack>
        </Stack>
      </Inline>

      <p className="text-sm font-medium leading-6 tracking-tight text-black">{formattedAmount}</p>
    </Inline>
  );
};
